import { createContext, useContext } from 'react';

export const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

// Links stay inside the current view: '/day' becomes '/me/day' for the owner.
export const useAppPath = () => {
  const { base } = useApp();
  return (path) => (base && path === '/' ? base : `${base}${path}`);
};
